<template>
	<div>
		<case-form :schema="schema" />
	</div>
</template>

<script>
import CaseForm from "../../CaseForm/CaseForm.vue"

export default {
	name: "CBProposalOutsideLimit",
	components: { CaseForm },
	data() {
		return {
			schema: [
				{
					component: "html",
					props: {
						content:
							"<div class='fs4 fw7 lh125'>6. (III) What limit is required for any one loss for property / elsewhere than at the Proposer's premises stated in Question 1(b)? (This limit will NOT apply to property in any safe deposit vault or bank vault.)</div>"
					},
					bindTo: ""
				},
				{
					label: "Insured Property",
					component: "text",
					bindTo: "case.facts.outsidePremisesLossLimitInsuredProperty"
				},
				{
					label: "Money",
					component: "text",
					bindTo: "case.facts.outsidePremisesLossLimitMoney"
				}
			]
		}
	}
}
</script>
